import { render, staticRenderFns } from "./IncomeChangeDetails.vue?vue&type=template&id=109c0952"
import script from "./IncomeChangeDetails.vue?vue&type=script&lang=js"
export * from "./IncomeChangeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports